import { Button } from "@mui/material";
import React from "react";

const PassengerActionButton = ({ handleClick, value, icon }) => {
  return (
    <Button
      variant="outlined"
      className="me-2"
      sx={{
        borderColor: "gray",
        color: "gray",
        "&:hover": {
          borderColor: "darkgray",
          color: "darkgray",
        },
      }}
      onClick={handleClick}
    >
      {icon || value}
    </Button>
  );
};

export default PassengerActionButton;
